import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
// import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
// import { TanStackDevtools } from '@tanstack/react-devtools'

// import TanStackQueryDevtools from '../integrations/tanstack-query/devtools'
import type { QueryClient } from '@tanstack/react-query'
import { NotFound } from '@/components/not-found'
import { Toaster } from '@/components/ui/sonner'
import { NavigationLoader } from '@/components/shared/navigation-loader'
import { PageTitle } from '@/components/shared/page-title'
import { IsaAvatarProvider } from '@/components/shared/isa-avatar-context'


interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => {
    return (
      <>
        <IsaAvatarProvider>
          <PageTitle />
          <NavigationLoader />
          <Outlet />
        </IsaAvatarProvider>

        <Toaster />
        {/* import.meta.env.DEV && (
          <TanStackDevtools
            config={{
              position: 'top-left',
              panelLocation: 'top',
            }}
            plugins={[
              {
                name: 'Tanstack Router',
                render: <TanStackRouterDevtoolsPanel />,
              },
              TanStackQueryDevtools,
            ]}
          />
        )*/}
      </>
    )
  },
  notFoundComponent: NotFound,
})
